import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import Section from "../../shared/Section";
import ManifestDetails from "./ManifestDetails";
import usePrevious from "../../../hooks/usePrevious";
import { Container } from "react-bootstrap";
import { useIsRegulator } from "../../../hooks";
import { Loading } from "../../shared";

function SingleManifestSearch(props) {
  const isRegulator = useIsRegulator();
  const [manifest, setManifest] = useState([]);
  const [generator, setGenerator] = useState([]);
  const [TSDF, setTsdf] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();
  const params = useParams();
  const [manifestId, setManifestId] = useState(params.manifest_id);
  const prevManifestId = usePrevious(manifestId);

  //create function to call api
  const getManifestDetail = (manifest_id, version_no) => {
    axios
      .get(
        `api/v1/hwts/search/manifest/search/id?manifestId=${manifest_id}&versionNo=${version_no}`
      )
      .then((manifest) => {
        if (manifest.data.manifest.length === 0 && manifest.data.images.length > 0) {
          let manifestDummy = {
            EM_ID: "",
            COPY_TYPE_IND: "",
            VERSION_ID: "",
            MANIFEST_ID: params.manifest_id,
            GEN_EPA_ID: manifest.data.images[0].EpaId,
            GEN_NAME: "",
            TSDF_EPA_ID: "",
            TSDF_ALT_ID: "",
            TRANSPORTER_EPA_ID: [],
            SHIPMENT_DATE: "",
            RECEIPT_DATE: "",
            ORIGIN_TYPE: "",
            DOC_NAME: ""
          }

          let manifestDummyArray = [manifestDummy];

          let wasteStreamDummy = {
            LINE_NO: "",
            CONTR_TYPE_CODE: "",
            CONV_QNTY_TONS: "",
            METH_CODE: "",
            NBR_CONTR: "",
            QNTY_UNIT: "",
            WASTE_QNTY: "",
            RCRA_CODE: "",
            WASTE_STATE_CODE: "",
            COI: ""
          }
          let wasteDummyArray = [wasteStreamDummy];
          let dummy = {
            manifest: manifestDummyArray,
            wasteStreams: wasteDummyArray,
            versions: [],
            images: manifest.data.images,
          }
          setManifest(dummy);
        } else {
          setManifest(manifest.data);
        }

        if (manifest.data.manifest.length > 0) {
          axios
            .get(
              `api/v1/hwts/search/facility?epaid=${manifest.data.manifest[0].GEN_EPA_ID}`
            )
            .then((generator) => {
              setGenerator(generator.data[0]);
            });
          axios
            .get(
              `api/v1/hwts/search/facility?epaid=${manifest.data.manifest[0].TSDF_EPA_ID}`
            )
            .then((tsdf) => {
              setTsdf(tsdf.data[0]);
            });
        }

        setIsFetching(false);
        setIsLoading(false);
      });
  };

  const onVersionChange = (e) => {
    setIsFetching(true);
    getManifestDetail(manifestId, e.target.value);
  };

  const onSearchManifest = (manifest_id) => {
    setIsFetching(true);
    history.push(`/manifest/${manifest_id}`);
    setManifestId(manifest_id);
    setTimeout(function () {
      getManifestDetail(manifest_id, 0);
    }, 2000);
  };

  useEffect(() => {
    if (manifestId !== "" && prevManifestId !== manifestId && isLoading) {
      getManifestDetail(manifestId, 0);
    }
  }, [isFetching]);

  return (
    <React.Fragment>
      <Section title={"Manifest Detail"} type={"standout"} />
      {isLoading ? (
        <Loading />
      ) : (
          <Container>
            <ManifestDetails
              isFetching={isFetching}
              onSearchManifest={onSearchManifest}
              Manifest={manifest.manifest[0]}
              isRegulator={isRegulator}
              wasteStreams={manifest.wasteStreams}
              manifestVersion={manifest.versions}
              onVersionChange={onVersionChange}
              manifestImages={manifest.images}
              GENERATOR={generator}
              TSDF={TSDF}
            />
          </Container>
        )}
    </React.Fragment>
  );
}

export default SingleManifestSearch;
